<template>

  <div :class="`bubble ${timeout ? 'bubble_disabled' : ''}`" @click="clickHandler()">

    <!-- <div :class="`bubble_pseudo ${answer ? 'bubble_pseudo_t' : answer === false ? 'bubble_pseudo_f' : ''}`"></div> -->

    <svg v-show="answer" width="343" height="94" viewBox="0 0 343 94" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 36.5C3 17.9985 17.9985 3 36.5 3H306.5C325.002 3 340 17.9985 340 36.5C340 55.0015 325.002 70 306.5 70H86C85.4477 70 85 70.4477 85 71V91L61.4168 71.1901C60.5017 70.4214 59.3448 70 58.1497 70H36.5C17.9985 70 3 55.0015 3 36.5Z" fill="url(#paint0_linear_414_338)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M86.2671 93.7193C85.2101 94.2118 83.9634 94.0472 83.0704 93.2971L59.4872 73.4872C59.1126 73.1725 58.639 73 58.1497 73H36.5C16.3416 73 0 56.6584 0 36.5C0 16.3416 16.3416 0 36.5 0H306.5C326.658 0 343 16.3416 343 36.5C343 56.6584 326.658 73 306.5 73H88V91C88 92.1662 87.3242 93.2267 86.2671 93.7193ZM85 71C85 70.4477 85.4477 70 86 70H306.5C325.002 70 340 55.0015 340 36.5C340 17.9985 325.002 3 306.5 3H36.5C17.9985 3 3 17.9985 3 36.5C3 55.0015 17.9985 70 36.5 70H58.1497C59.3448 70 60.5017 70.4214 61.4168 71.1901L85 91V71Z" fill="black"/>
      <defs>
      <linearGradient id="paint0_linear_414_338" x1="0" y1="0" x2="340" y2="0" gradientUnits="userSpaceOnUse">
      <stop :offset="filledP" stop-color="#AFF70C"/>
      <stop :offset="filledP" stop-color="white"/>
      </linearGradient>
      </defs>
    </svg>

    <svg v-show="answer === false" width="343" height="94" viewBox="0 0 343 94" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 36.5C3 17.9985 17.9985 3 36.5 3H306.5C325.002 3 340 17.9985 340 36.5C340 55.0015 325.002 70 306.5 70H283.272C283.096 70 282.926 70.0619 282.792 70.1749L258 91V77C258 73.134 254.866 70 251 70H36.5C17.9985 70 3 55.0015 3 36.5Z" fill="url(#paint0_linear_416_346)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M256.733 93.7193C257.79 94.2118 259.037 94.0472 259.93 93.2971L283.513 73.4872C283.887 73.1725 284.361 73 284.85 73H306.5C326.658 73 343 56.6584 343 36.5C343 16.3416 326.658 0 306.5 0H36.5C16.3416 0 0 16.3416 0 36.5C0 56.6584 16.3416 73 36.5 73H255V91C255 92.1662 255.676 93.2267 256.733 93.7193ZM258 71C258 70.4477 257.552 70 257 70H36.5C17.9985 70 3 55.0015 3 36.5C3 17.9985 17.9985 3 36.5 3H306.5C325.002 3 340 17.9985 340 36.5C340 55.0015 325.002 70 306.5 70H284.85C283.655 70 282.498 70.4214 281.583 71.1901L258 91V71Z" fill="black"/>
      <defs>
      <linearGradient id="paint0_linear_416_346" x1="0" y1="0" x2="340" y2="0" gradientUnits="userSpaceOnUse">
      <stop :offset="filledP" stop-color="#D457FF"/>
      <stop :offset="filledP" stop-color="white"/>
      </linearGradient>
      </defs>
    </svg>

    <p class="bubble-text" v-html="text"></p>

  </div>

</template>

<script>

export default {

  name: 'Bubble',

  props: ['answer', 'text', 'i', 'timeout'],

  data(){

    return{
      filledP: 0,
      int: ''
    }

  },

  watch: {
    answer: {
      handler(newValue)  {

        if (newValue !== null) {

          this.filledP = 0

          setTimeout(() => {

            this.int = setInterval(() => {

              this.filledP += this.i

              if (this.filledP >= 1) {
                this.filledP = 1
                clearInterval(this.int)
                this.$emit('clipFinished')
              }

            }, 500);

          }, 1000);

        }

      }
    }
  },

  methods:{
    clickHandler(){

      if (this.timeout) {
        return
      }
      this.$emit('click')
      clearInterval(this.int)
    }
  }

}
</script>

<style lang="sass">

@keyframes puls
  0%
    transform: scale(1)
  40%
    transform: scale(1)
  50%
    transform: scale(1.05)
  60%
    transform: scale(1)
  100%
    transform: scale(1)

.bubble
  overflow: hidden
  width: 282px
  height: 74px
  position: absolute
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  cursor: pointer

  bottom: calc(50% - 200px)


  svg, &-text
    animation: 3s linear 2.5s infinite running puls

  &_disabled
    filter: brightness(.5)
    cursor: default

  &_pseudo
    position: absolute
    width: 319px
    height: 78.62px
    // top: -2px

    &_t
      background-image: url(../assets/img/bubble_t.svg)

    &_f
      background-image: url(../assets/img/bubble_f.svg)

  &_false
    transform-origin: right bottom

  &_true
    transform-origin: left bottom

  &-text
    color: black
    position: absolute
    font-size: .90em
    line-height: 120%
    max-width: 90%
    font-weight: 400
    text-align: center
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding-bottom: 20px

@media (max-width: 420px)
  .bubble
    width: 79vw
    height: 20.625vw
    bottom: calc(50% - 56vw)

    &_pseudo
      width: 80vw
      height: 22vw
      // top: -0.6vw

    &-text
      font-size: 1em
      padding: 0 4vw 5vw

</style>
